/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
  selector: '[scrollToFirstInvalid]',
  standalone: true,
})
export class ScrollToFirstInvalidDirective {
  @Input()
  formGroup!: FormGroup;

  @HostListener('ngSubmit', ['$event'])
  onSubmit(e: Event) {
    if (this.formGroup.invalid) {
      const invalidEl = this.findFirstInvalid();
      if (invalidEl) {
        this.scrollIntoView(invalidEl);
        invalidEl.focus();
        invalidEl.blur();
        invalidEl.focus();
      }
    }
  }

  private findFirstInvalid(): HTMLInputElement | null {
    return this.el.nativeElement.querySelector('input.ng-invalid:not(form)');
  }

  private scrollIntoView(el: Element): void {
    el.scrollIntoView({ block: 'center' });
  }

  constructor(private el: ElementRef<HTMLFormElement>) {}
}
